var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 23.563,
    viewBox: "0 0 29 23.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter",
    transform: "translate(0 -48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3315",
    "data-name": "Group 3315",
    transform: "translate(0 48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3314",
    "data-name": "Group 3314",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M20.52 48H23.72L16.7 56.25L24.9 68.45H18.48L13.42 61.87L7.72 68.45H4.52L11.98 59.09L4.11 48H10.7L15.27 54.27L20.52 48ZM19.38 66.42H21.16L9.75 51.14H7.84L19.38 66.42Z",
    transform: "translate(0 -48)",
    fill: "#fff"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.03d949c733fcaa1cd78b78d635564b33.svg";
export { ForwardRef as ReactComponent };